import { useSetState } from '@/shared/lib/customHooks';

/**
 * Holds the study info drawer state for the support request study table. Tracks drawer visibility together with the study id to fetch and exposes the toggle.
 *
 * @returns Drawer state and its toggle handler.
 */
export const useSupportTableStudy = () => {
  const [state, setState] = useSetState({
    isVisibleStudyInfoDrawer: false,
    fetchStudyId: '',
  });

  /**
   * Opens or closes the study info drawer of the support request study table. Clears fetchStudyId and hides the drawer when it is already visible, otherwise stores row.study.id and shows it.
   *
   * @param row - Study record whose study id should be loaded.
   * @returns Nothing.
   */
  const toggleDisplayDrawer = (row?: any) => {
    if (state.isVisibleStudyInfoDrawer) {
      setState({
        isVisibleStudyInfoDrawer: false,
        fetchStudyId: '',
      });
    } else {
      setState({
        isVisibleStudyInfoDrawer: true,
        fetchStudyId: row?.study?.id,
      });
    }
  };

  return { state, toggleDisplayDrawer };
};
